export enum LOAN_SETTLEMENT_NEGOTIATION_STATUS {
    IN_PROGRESS = 'In_Progress',
    PENDING = 'Pending',
    REJECTED = 'Rejected',
    ACCEPTED = 'Accepted',
}

export class SettledLoansDetails {
    public _id: string;
    public investedAmount: number;
    public loanId: string;
    public lenderId: string;
    public portfolioId: string;
    public productCode: string;
    public loanSanctionStatus: string;
    public loanFulfilledAmount: number;
    public loanAmount: number;
    public grossCashFlowReceivedBeforeSettlement: number;
    public principalOutstandingBeforeSettlement: number;
    public settlementAmountOffered: number;
    public settlementAmountDemanded: number;
    public grossCashFlowReceivedPostSettlement: number;
    public settlementNegotiationStatus: LOAN_SETTLEMENT_NEGOTIATION_STATUS;
    public generatedLoanId: string;
    public readonly createdAt: Date;
    public readonly updatedAt: Date;

    constructor(
        investedAmount: number,
        loanId: string,
        lenderId: string,
        portfolioId: string,
        productCode: string,
        loanSanctionStatus: string,
        loanFulfilledAmount: number,
        loanAmount: number,
        grossCashFlowReceivedBeforeSettlement: number,
        principalOutstandingBeforeSettlement: number,
        settlementAmountOffered: number,
        settlementAmountDemanded: number,
        grossCashFlowReceivedPostSettlement: number,
        settlementNegotiationStatus: LOAN_SETTLEMENT_NEGOTIATION_STATUS,
        generatedLoanId: string,
        createdAt?: Date,
        updatedAt?: Date
    ) {
        this.investedAmount = investedAmount;
        this.loanId = loanId;
        this.lenderId = lenderId;
        this.portfolioId = portfolioId;
        this.productCode = productCode;
        this.loanSanctionStatus = loanSanctionStatus;
        this.loanFulfilledAmount = loanFulfilledAmount;
        this.loanAmount = loanAmount;
        this.grossCashFlowReceivedBeforeSettlement = grossCashFlowReceivedBeforeSettlement;
        this.principalOutstandingBeforeSettlement = principalOutstandingBeforeSettlement;
        this.settlementAmountOffered = settlementAmountOffered;
        this.settlementAmountDemanded = settlementAmountDemanded;
        this.grossCashFlowReceivedPostSettlement = grossCashFlowReceivedPostSettlement;
        this.settlementNegotiationStatus = settlementNegotiationStatus;
        this.generatedLoanId = generatedLoanId;
        this.createdAt = createdAt || new Date();
        this.updatedAt = updatedAt || new Date();
    }

    static createFrom(params: {
        investedAmount: number;
        loanId: string;
        lenderId: string;
        portfolioId: string;
        productCode: string;
        loanSanctionStatus: string;
        loanFulfilledAmount: number;
        loanAmount: number;
        grossCashFlowReceivedBeforeSettlement: number,
        principalOutstandingBeforeSettlement: number,
        settlementAmountOffered: number,
        settlementAmountDemanded: number,
        grossCashFlowReceivedPostSettlement: number,
        settlementNegotiationStatus: LOAN_SETTLEMENT_NEGOTIATION_STATUS;
        generatedLoanId: string;
        createdAt?: Date,
        updatedAt?: Date
    }): SettledLoansDetails {
        return new SettledLoansDetails(
            params.investedAmount,
            params.loanId,
            params.lenderId,
            params.portfolioId,
            params.productCode,
            params.loanSanctionStatus,
            params.loanFulfilledAmount,
            params.loanAmount,
            params.grossCashFlowReceivedBeforeSettlement,
            params.principalOutstandingBeforeSettlement,
            params.settlementAmountOffered,
            params.settlementAmountDemanded,
            params.grossCashFlowReceivedPostSettlement,
            params.settlementNegotiationStatus,
            params.generatedLoanId,
            new Date(),
            new Date()
        );
    }

}

export class LoanSettlementNegotiation {
    public readonly _id: string;
    public readonly lenderId: string;
    public settledLoansDetails: SettledLoansDetails[];

    public readonly createdAt: Date;

    constructor(
        lenderId: string,
        settledLoansDetails: SettledLoansDetails[],
    ) {
        this.lenderId = lenderId;
        this.settledLoansDetails = settledLoansDetails;
    }

    public static createFrom(obj: Partial<LoanSettlementNegotiation>): LoanSettlementNegotiation {
        const loanSuggestedTerms = new LoanSettlementNegotiation(
            obj.lenderId,
            obj.settledLoansDetails,
        );
        return loanSuggestedTerms;
    }
}
